import { COUNTRIES, Country } from '../data/countries';

export interface ParsedAddress {
  country: Country | null;
  countryCode: string | null;
  city: string | null;
  fullAddress: string;
}

export const parseAddress = (address: string): ParsedAddress => {
  if (!address) {
    return {
      country: null,
      countryCode: null,
      city: null,
      fullAddress: address
    };
  }

  if (address.startsWith('Lat:')) {
    return {
      country: null,
      countryCode: null,
      city: 'Ubicación personalizada',
      fullAddress: address
    };
  }

  const parts = address.split(',').map(part => part.trim());

  let countryName = '';
  let cityName = '';

  if (parts.length > 0) {
    countryName = parts[parts.length - 1];
  }

  if (parts.length >= 2) {
    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i];
      if (part.length >= 3 && !/^\d+$/.test(part)) {
        cityName = part;
        break;
      }
    }
  }

  const matchedCountry = COUNTRIES.find(country =>
    country.name.toLowerCase() === countryName.toLowerCase() ||
    country.nameEn.toLowerCase() === countryName.toLowerCase() ||
    country.code.toLowerCase() === countryName.toLowerCase()
  );

  return {
    country: matchedCountry || null,
    countryCode: matchedCountry?.code || null,
    city: cityName || parts[0] || null,
    fullAddress: address
  };
};

export const extractCountryFromAddress = (address: string): string | null => {
  const parsed = parseAddress(address);
  return parsed.countryCode;
};

export const extractCityFromAddress = (address: string): string | null => {
  const parsed = parseAddress(address);
  return parsed.city;
};

export const groupByCountry = (addresses: string[]): Map<string, number> => {
  const countryMap = new Map<string, number>();

  addresses.forEach(address => {
    const countryCode = extractCountryFromAddress(address);
    if (countryCode) {
      const currentCount = countryMap.get(countryCode) || 0;
      countryMap.set(countryCode, currentCount + 1);
    }
  });

  return countryMap;
};
